<a [airLink]="pageUrl" [userEventSource]="userEventSource" class="banner" [ngClass]="'banner--' + theme">
  <i class="icon banner__icon" [ngClass]="icon"></i>
  <span class="banner__message">
    <ng-content></ng-content>
  </span>
  <span class="banner__action" *ngIf="pageUrl?.length">
    <span class="d--none--sm">{{ action }}</span>
    <i class="icon icon-ui-arrow--right--sm"></i>
  </span>
</a>
